var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1925 0C5.88479 0 0 5.99414 0 13.4473V58.5703C0 66.0059 5.88479 72 13.1925 72H13.7897C21.0974 72 26.9822 66.0059 26.9822 58.5703V13.4473C26.9822 5.99414 21.0974 0 13.7897 0L13.1925 0ZM24.8566 0C28.8091 3.2168 31.4616 8.06836 31.4616 13.5V18H41.0178C40.6841 13.0781 46.6391 9 50.0119 9C53.0685 9 54.5089 9.05274 54.5089 13.5V18H59.9897C65.5231 15.293 68 9.14062 68 5.90625C68 2.60156 57.2669 0 51.4172 0H24.8566ZM31.4792 22.5V41.9062C43.9163 53.877 59.0235 52.7344 59.0235 52.7344C59.0235 52.7344 60.6045 45.8965 50.451 34.5938L39.7706 22.5H31.7603C31.6724 22.5176 31.567 22.4824 31.4792 22.5ZM44.8649 33.8906L52.4361 41.7129C44.3379 42.4512 42.7569 37.8457 44.8649 33.8906Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe5);
export default __webpack_public_path__ + "static/media/serve5.cd5bde618081f062fd14c89534692f68.svg";
export { ForwardRef as ReactComponent };